import { ReactComponent as AdIcon } from 'img/icons/subscriptions/ad-icon.svg';
import { ReactComponent as AvailableSpaceIcon } from 'img/icons/subscriptions/available-space-icon.svg';
import { ReactComponent as CallIcon } from 'img/icons/subscriptions/call-icon.svg';
import { ReactComponent as FilesIcon } from 'img/icons/subscriptions/files-icon.svg';
import { ReactComponent as MailIcon } from 'img/icons/subscriptions/mail-icon.svg';
import React, { forwardRef } from 'react';

import { DialogProps } from '../CancelAutoRenewalModal.types';
import styles from './PrivilegeList.css';

const iconProps = {
    width: 32,
    height: 32,
} as const;

const privileges = [
    { Icon: AvailableSpaceIcon, getText: (s: string) => `${s} в Почте и Облаке` },
    { Icon: AdIcon, getText: () => 'Отключение рекламы' },
    { Icon: FilesIcon, getText: () => 'Возможность сохранять в Облаке файлы более 2 ГБ' },
    { Icon: MailIcon, getText: () => 'Возможность отправлять файлы более 2 ГБ' },
    { Icon: CallIcon, getText: () => 'Приоритетную поддержку' },
] as const;

type Props = Pick<DialogProps, 'currentSpace'>;

export const PrivilegeList = forwardRef<HTMLDivElement, Props>(({ currentSpace }, ref) => (
    <div className={styles.root} ref={ref}>
        {privileges.map(({ Icon, getText }, idx) => (
            <div key={idx} className={styles.item}>
                <div className={styles.icon}>
                    <Icon {...iconProps} />
                </div>
                <span>{getText(currentSpace)}</span>
            </div>
        ))}
    </div>
));

PrivilegeList.displayName = 'PrivilegeList';
